<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Engineering Science"
                   :links="[{title:'Home', url:'/'},{title:'News Events'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="12"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">News Events</div>
          <TabView>
            <tab-panel header="News">
              <activity-component v-for="news in newsList" :key="news" :activity="news"></activity-component>
            </tab-panel>
            <tab-panel header="Events">
              <activity-component v-for="event in events" :key="event" :activity="event"></activity-component>
            </tab-panel>
          </TabView>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/science/Sidebar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ActivityComponent from "@/components/ActivityComponent";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "News_Events",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView, TabPanel,
    ActivityComponent
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      newsList: [
        {
          name: "एस. एन. डी. अभियांत्रिकीच्या विद्यार्थ्यांची निवड. कॅम्पस प्लेसमेन्ट ४० विध्यार्त्यांना कंपनीत नोकरी",
          date: "26 Oct 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/news/n1.jpg",
              "thumbnailImageSrc": "",
              "alt": "कॅम्पस प्लेसमेन्ट",
              "title": "एस. एन. डी. अभियांत्रिकीच्या महाविद्याल"
            },
          ]
        },
        {
          name: "एस. एन. डी. अभियांत्रिकीच्या महाविद्यालयात डॉ. कलाम यांची जयंती उत्साहात ",
          date: "15 Oct 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/news/n2.jpg",
              "thumbnailImageSrc": "",
              "alt": " डॉ. कलाम यांची जयंती उत्साहात ",
              "title": "एस. एन. डी. अभियांत्रिकीच्या महाविद्याल"
            }
          ]
        },
        {
          name: "एस. एन. डी. अभियांत्रिकीच्या महाविद्यालयात गणपती बाप्पांचे उत्साहात विसर्जन ",
          date: "24 Sep 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/news/n3.jpg",
              "thumbnailImageSrc": "",
              "alt": "गणपती बाप्पांचे उत्साहात विसर्जन",
              "title": "एस. एन. डी. अभियांत्रिकीच्या महाविद्याल"
            }]
        },
        {
          name: "एस. एन. डी. अभियांत्रिकीच्या महाविद्यालयात मिळणार विध्यार्थ्यांच्या हाताला काम ",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/news/n4.jpg",
              "thumbnailImageSrc": "",
              "alt": "विध्यार्थ्यांच्या हाताला काम",
              "title": "एस. एन. डी. अभियांत्रिकीच्या महाविद्याल"
            }
          ]
        },
        {
          name: "एस. एन. डी. अभियांत्रिकीच्या महाविद्यालयात प्रथम वर्षाचा निकाल १०० टक्के ",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/news/n8.jpg",
              "thumbnailImageSrc": "",
              "alt": "प्रथम वर्षाचा निकाल १०० टक्के ",
              "title": "एस. एन. डी. अभियांत्रिकीच्या महाविद्याल"
            }
          ]
        }
      ],
      events: [
        {
          name: "Soft Skill Development ProgrammeSoft Skill Development Programme",
          date: "2020-21",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/events/e1.jpg",
              "thumbnailImageSrc": "/static/images/science/newsEvents/events/e2.jpg",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },
          ]
        },
        {
          name: "Personality Development Programme",
          date: "2020-21",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/events/e3.jpg",
              "thumbnailImageSrc": "/static/images/science/newsEvents/events/e4.jpg",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },
          ]
        },
        {
          name: "Seminar on Mind & Memory and Concentration",
          date: "2020-21",
          details: "Speaker: Dr. K.V. Swaminath (IIT Mumbai)",
          images: [
            {
              "itemImageSrc": "/static/images/science/newsEvents/events/e5.jpg",
              "thumbnailImageSrc": "",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },
          ]
        },

      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
